export enum ObservableObjectCondition {
  Unknown = "Unknown",
  Deleted = "Deleted",
  NoAccess = "NoAccess",
  InTrash = "InTrash",
  ReadAccess = "ReadAccess",
  WriteAccess = "WriteAccess",
}
